<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
  <div class="page-container">
    <!-- Page Header -->
    <div class="page-header">
      <button mat-icon-button routerLink="/user-profiles" class="back-button">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="header-content">
        <h2>Editar Grupo de Usuário</h2>
        <p class="header-subtitle">Altere as informações e permissões do grupo</p>
      </div>
    </div>

    @if (currentProfile !== null) {
      <app-user-profile-form (change)="onFormChange($event)" [formData]="currentProfile" />
    }

    <!-- Actions -->
    <div class="form-actions">
      <button mat-stroked-button color="primary" routerLink="/user-profiles">
        <mat-icon>close</mat-icon>
        <span>Cancelar</span>
      </button>
      <button mat-flat-button color="primary" (click)="submitForm()">
        <mat-icon>check</mat-icon>
        <span>Salvar Alterações</span>
      </button>
    </div>
  </div>
</mic-spinner-overlay>
